export default "__VITE_ASSET__DPtMg2Mo__"